import { Locale } from 'vant'
import i18n from '@/locales'
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, normalizeLocale } from '@/locales/localeConfig'

// 安全的localStorage操作
const safeSetLocalStorage = (key, value) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(key, value)
      return true
    }
  } catch (error) {
    console.warn('localStorage设置失败:', error)
  }
  return false
}

const safeGetLocalStorage = (key, defaultValue = null) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem(key) || defaultValue
    }
  } catch (error) {
    console.warn('localStorage读取失败:', error)
  }
  return defaultValue
}

export const changeLanguage = (lang) => {
  try {
    const normalized = normalizeLocale(lang)
    if (!SUPPORTED_LANGUAGES.includes(normalized)) {
      console.warn(`不支持的语言: ${lang}, 回退到默认语言`)
      lang = DEFAULT_LANGUAGE
    } else {
      lang = normalized
    }
    
    // 检查i18n是否已初始化
    if (!i18n || !i18n.global) {
      console.error('i18n未初始化')
      return false
    }
    
    // 检查消息是否存在
    if (!i18n.global.messages.value || !i18n.global.messages.value[lang]) {
      console.error(`语言包不存在: ${lang}`)
      return false
    }
    
    // 设置 i18n 语言
    i18n.global.locale.value = lang
    
    // 安全保存到本地存储
    safeSetLocalStorage('lang', lang)
    
    // 更新 Vant 组件语言
    try {
      const vantMessages = i18n.global.messages.value[lang]?.vant
      if (vantMessages) {
        const vantLocale = lang === 'CN' ? 'zh-CN' : lang === 'TW' ? 'zh-TW' : lang === 'TR' ? 'tr-TR' : 'en-US'
        Locale.use(vantLocale, vantMessages)
      } else {
        console.warn(`Vant语言包不存在: ${lang}`)
        // 使用默认的US语言
        const defaultVantMessages = i18n.global.messages.value[DEFAULT_LANGUAGE]?.vant
        if (defaultVantMessages) {
          Locale.use('en-US', defaultVantMessages)
        }
      }
    } catch (vantError) {
      console.error('Vant语言设置失败:', vantError)
    }
    
    return true
    
  } catch (error) {
    console.error('语言切换失败:', error)
    return false
  }
}

export const getLanguage = () => {
  const stored = safeGetLocalStorage('lang', DEFAULT_LANGUAGE)
  const normalized = normalizeLocale(stored)
  if (SUPPORTED_LANGUAGES.includes(normalized)) {
    return normalized
  }
  console.warn(`无效的存储语言: ${stored}, 回退到默认语言`)
  return DEFAULT_LANGUAGE
}
